var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.active)?_c('span',{staticClass:"text-xs px-2 py-0.5 font-bold bg-red-100 text-red-600 rounded"},[_vm._v("\n  Não\n")]):_c('span',{staticClass:"text-xs px-2 py-0.5 font-bold bg-green-100 text-green-600 rounded"},[_vm._v("\n  Sim\n")])}
var staticRenderFns = []

export { render, staticRenderFns }